import { Button } from "@ptsd/uikit";
import { Anchor, useMedia, View } from "tamagui";

import { phoneToHuman } from "~/utils/formatters";
import { IconPhone } from "~/component/feature/paywall/icons/icon-phone";
import { track } from "~/hooks/use-track";

export const CallToDoctorButton = ({
  phoneNumber,
}: {
  phoneNumber: string;
}) => {
  const { sm } = useMedia();
  return (
    <Anchor href={"tel:" + phoneNumber} textDecorationLine="none" asChild>
      <Button
        style={{
          background:
            "linear-gradient(90deg,rgba(0, 188, 125, 1) 0%, rgba(0, 150, 137, 1) 100%)",
          color: "white",
        }}
        onPress={() => {
          track("Click On Appointment Phone Number");
        }}
        size={sm ? "md" : "lg"}
        rounded={"md"}
      >
        <View
          flex={1}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={"$1"}
        >
          <IconPhone /> {phoneToHuman(phoneNumber)}
        </View>
      </Button>
    </Anchor>
  );
};
